import { Configuration, ConfigurationParameters } from 'src/Services/API/generated';

import { transformResponse } from './transform';

export interface CustomConfigurationParameters extends ConfigurationParameters {
  transformResponse?: boolean;
}

export class CustomConfiguration extends Configuration {
  constructor(params: CustomConfigurationParameters = {}) {
    super(params);

    if (params.transformResponse) {
      this.baseOptions = {
        ...this.baseOptions,
        transformResponse: [
          (data: string) => {
            if (data && typeof data === 'string') {
              try {
                const jsonData = JSON.parse(data);
                return transformResponse(jsonData);
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
              } catch (error) {
                return data;
              }
            }

            return data;
          },
        ],
      };
    }
  }
}
